enum CELL_VALUE {
  DOWN = -1,
  UP = 1,
  MIDDLE = 0,
}

export default CELL_VALUE;
